import React from 'react'

export default function EditWall() {
  return (
    <div className="unpublish-warning-container flex-row padding-5 align-center justify-center">
      <div className="unpublish-warning-message">Unpublish this form to enable editing</div>
    </div>
  )
}
